import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { bedrijf } from "../data/content";

const links = [
  { label: "Home", id: "home" },
  { label: "Arrangementen", id: "arrangementen" },
  { label: "Thema's", id: "themas" },
  { label: "Mogelijkheden", id: "mogelijkheden" },
  { label: "Over De Proatkoele", id: "over" },
  { label: "Contact", id: "contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`sticky top-0 z-50 border-b transition-all duration-300 ${
        scrolled ? "bg-background/95 backdrop-blur-md border-border" : "bg-background/80 backdrop-blur-sm border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16 md:h-20">
        <button
          data-testid="nav-logo"
          onClick={() => scrollTo("home")}
          className="font-heading text-xl md:text-2xl font-semibold tracking-tight text-foreground"
        >
          De Proatkoele
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="text-foreground/80 hover:text-primary font-medium transition-colors"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-reserveren-button"
            href="/reserveren"
            className="text-foreground/80 hover:text-primary font-medium transition-colors"
          >
            Reserveren
          </a>
          <a
            data-testid="nav-call-button"
            href={`tel:${bedrijf.telefoonRaw}`}
            className="inline-flex items-center gap-2 bg-primary text-primary-foreground font-medium rounded-full px-5 py-2.5 hover:bg-primary-hover transition-colors"
          >
            <Phone size={16} /> Bel ons
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-foreground p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden border-t border-border bg-background px-4 py-4 space-y-1">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="block w-full text-left py-2.5 text-foreground/80 hover:text-primary font-medium"
            >
              {l.label}
            </button>
          ))}
          <a
            href="/reserveren"
            data-testid="nav-mobile-reserveren"
            className="block w-full text-left py-2.5 text-foreground/80 hover:text-primary font-medium"
          >
            Reserveren
          </a>
          <a
            href={`tel:${bedrijf.telefoonRaw}`}
            className="mt-2 inline-flex w-full items-center justify-center gap-2 bg-primary text-primary-foreground font-medium rounded-full px-5 py-3"
          >
            <Phone size={18} /> Bel {bedrijf.telefoon}
          </a>
        </div>
      )}
    </header>
  );
};
